import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=0622d5d2&scoped=true"
import script from "./MenuManager.vue?vue&type=script&lang=js"
export * from "./MenuManager.vue?vue&type=script&lang=js"
import style0 from "./MenuManager.vue?vue&type=style&index=0&id=0622d5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622d5d2",
  null
  
)

export default component.exports